// src/services/defaultContentApi.ts
import api from './api';

export enum DefaultContentType {
  None = 0,
  Playlist = 1,
  Asset = 2
}

export interface DefaultContentResponse {
  defaultContentType: DefaultContentType;
  defaultContentId?: number;
  contentName?: string;
  contentType?: string;
  assetType?: string;
  itemCount?: number;
  hasSystemDefault: boolean;
  systemDefaultName?: string;
}

export interface UpdateDefaultContentRequest {
  defaultContentType: DefaultContentType;
  defaultContentId?: number;
}

export interface PlaylistOptionDto {
  playlistId: number;
  playlistName: string;
  itemCount: number;
}

export interface AssetOptionDto {
  assetId: number;
  assetName: string;
  fileType: string;
  duration?: number;
  fileSizeFormatted: string;
}

export interface DefaultContentOptionsResponse {
  playlists: PlaylistOptionDto[];  // Capitalized to match C# API
  assets: AssetOptionDto[];        // Capitalized to match C# API
}

class DefaultContentApi {
  // Get current default content configuration
  async getCurrentConfiguration(): Promise<DefaultContentResponse> {
    const response = await api.get('/DefaultContent');
    return response.data;
  }

  // Update default content configuration
  async updateConfiguration(request: UpdateDefaultContentRequest): Promise<DefaultContentResponse> {
    const response = await api.put('/DefaultContent', request);
    return response.data;
  }

  // Get available content options (playlists and assets)
  async getContentOptions(): Promise<DefaultContentOptionsResponse> {
    const response = await api.get('/DefaultContent/options');
    return response.data;
  }

  // Set system default asset (Super Admin only)
  async setSystemDefault(assetId: number): Promise<{ message: string }> {
    const response = await api.post('/DefaultContent/system-default', assetId);
    return response.data;
  }
}

export const defaultContentApi = new DefaultContentApi();